var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c("cargo-button-group-slider", [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "1", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.importFileBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "2", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.updateStatusHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.UpdateStatus")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "3", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.deleteBtnClickHandler()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.ClearThePackingInformation"))
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "4", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExportThePackingPlan")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "5", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportPackSlipBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v("PACK SLIP")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "6", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportShipmentReportBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v("Shipment Report")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "7", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportWeeklyLoadingPlanBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v("Weekly Loading Plan")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "8", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportWarehousingFeeBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.WarehousingFee")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "9", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportLoadingListBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v("loading List")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "10", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportPackSlipForFCLListExcelFile()
                        }
                      }
                    },
                    [_vm._v("Pack Slip For FCL")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "print", type: "success" },
                      on: { click: _vm.toPrint }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { height: "100%", "min-height": "300px" },
          attrs: {
            "left-style": {
              display: "flex",
              flexDirection: "column",
              "min-width": "250px",
              "max-width": "250px"
            },
            "right-style": {
              display: "flex",
              flexDirection: "column",
              width: "80%"
            }
          }
        },
        [
          _c("template", { slot: "left" }, [
            _c(
              "div",
              {
                staticClass: "section",
                staticStyle: { height: "100%", overflow: "hidden" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { float: "left", "margin-bottom": "13px" } },
                  [
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("SeaExport.ContainerList")))
                    ])
                  ]
                ),
                _c(
                  "el-scrollbar",
                  { staticStyle: { height: "100%" } },
                  _vm._l(_vm.elCardList, function(item, index) {
                    return _c(
                      "el-card",
                      {
                        key: index,
                        style:
                          item.uuid === _vm.containerUuid
                            ? "background-color: #E7F5FF;"
                            : "",
                        nativeOn: {
                          click: function($event) {
                            return _vm.containerClickHandler(item)
                          }
                        }
                      },
                      [
                        _c("div", { staticStyle: { cursor: "pointer" } }, [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  float: "left",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v(" " + _vm._s(item.eqSizeAndType) + " ")]
                            ),
                            _c(
                              "div",
                              { staticStyle: { float: "right", color: "red" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.CommonState.getNameByCode(
                                        _vm.SeaExportConstants.CONTAINER_STATE,
                                        item.state
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]),
                          _c("br"),
                          _c("br"),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.ContainerNo")) +
                                "：" +
                                _vm._s(item.containerNo) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.SealNo")) +
                                "：" +
                                _vm._s(item.sealNo) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("SeaExport.ActualPackingTime")) +
                                "：" +
                                _vm._s(item.loadingDate) +
                                " "
                            )
                          ])
                        ])
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]),
          _c("template", { slot: "right" }, [
            _c("div", { staticStyle: { padding: "5px 0" } }, [
              _c("div", { staticStyle: { float: "left" } }, [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.ContainerInfo")))
                ])
              ]),
              _c(
                "div",
                { staticStyle: { float: "right" } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: true,
                        "label-width": "90px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.totalLabel.OrderNumber } },
                        [_vm._v(" " + _vm._s(_vm.totalDesc.orderNum) + " ")]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.totalLabel.TotalPacking } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.totalDesc.estimatedTotalPackings) +
                              " / " +
                              _vm._s(_vm.totalDesc.totalPackings) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.totalLabel.TotalCubage } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.totalDesc.estimatedTotalCubages) +
                              " / " +
                              _vm._s(_vm.totalDesc.totalCubages) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.totalLabel.TotalWeight2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.totalDesc.estimatedTotalWeight) +
                              " / " +
                              _vm._s(_vm.totalDesc.totalWeight) +
                              " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "section", staticStyle: { flex: "1" } },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { "flex-grow": "1" },
                  attrs: {
                    "config-module": "130130",
                    "grid-options": _vm.gridOptions,
                    "grid-params": _vm.gridParams,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        2
      ),
      _c("check-the-goods-window", {
        attrs: {
          visible: _vm.goodsDialog.visible,
          "result-list": _vm.goodsDialog.resultList || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.goodsDialog, "visible", $event)
          }
        }
      }),
      _c("check-the-packages-window", {
        attrs: {
          visible: _vm.packagesDialog.visible,
          "result-list": _vm.packagesDialog.resultList || []
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.packagesDialog, "visible", $event)
          }
        }
      }),
      _c("import-cabinet-list-window", {
        attrs: {
          visible: _vm.importCabinetListWindow.visible,
          "job-uuid": _vm.importCabinetListWindow.jobUuid
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.importCabinetListWindow, "visible", $event)
          },
          uploadExcelSuccess: _vm.loadPoInfoList
        }
      }),
      _c("update-container-po-window", {
        attrs: {
          visible: _vm.stateDialog.visible,
          state: _vm.stateDialog.state,
          "container-uuid": _vm.stateDialog.containerUuid,
          "actual-packing-time": _vm.stateDialog.actualPackingTime
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.stateDialog, "visible", $event)
          },
          fun: _vm.creationCompleteHandler,
          changeStateFun: _vm.changeStateFun
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }